const state = {
  current_profile_news_article_id: null,
  current_profile_tab_index: 0,
  current_row_id: null,
  
  current_edit_news_article_id: null,

  delete_news_article_id: null,
  update_news_article_id: null,
  
 };
 
 const actions = {};
 
 const mutations = {

  CURRENT_EDIT_NEWS_ARTICLE_ID(state, news_article_id) {
   state.current_edit_news_article_id = news_article_id;
  },
 
  SET_NEWS_ARTICLE_TAB_INDEX(state, tab_index) {
   state.current_profile_tab_index = tab_index
  },
  SET_NEWS_ARTICLE_ROW_ID(state, row_id) {
   state.current_row_id = row_id;
  },
  CLEAR_NEWS_ARTICLE_ROW_ID(state) {
   state.current_row_id = null;
  },
  
  SET_DELETE_NEWS_ARTICLE_ID(state, payload) {
   state.delete_news_article_id = payload;
  },
  SET_UPDATE_NEWS_ARTICLE_ID(state, payload) {
   state.update_news_article_id = payload;
  },
 };
 
 export default {
  state,
  actions,
  mutations
 }
 